import React, { Fragment, useEffect, useState } from "react";
import {
  Card,
  Typography,
  Button,
  Box,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import PageHeader from "../../../components/PageHeader/PageHeader";
import moment from "moment";
import MultiTemplateSender from "../Whatsapp/elements/MultiTemplateSender";
import { Waveform } from "@uiball/loaders";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { DataGrid } from "@mui/x-data-grid";
import { GlobalRefreshContext } from "../../../contexts/GlobalRefresh/GlobalRefresh";
import { BulkMessage } from "../../../api/Endpoints/BulkMessage";
import FilterListIcon from "@mui/icons-material/FilterList";
import Filters from "./elements/filters";
import FilterBadges from "../../../components/FilterBadge/FilterBadges";
import ProgressBox from "./elements/ProgressBox";

function Index() {
  const {
    watch,
    formState: { errors },
    control,
    Controller,
    setValue,
    reset,
  } = useForm({});
  const columns = [
    {
      field: "name",
      headerName: "Customer Name",
      width: 230,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              whiteSpace: "break-spaces",
            }}
          >
            <span
              style={{
                cursor: "pointer",
              }}
            >
              {params.row.name}
            </span>
          </div>
        );
      },
    },

    {
      field: "assigned_to_details",
      headerName: "Assign To",
      width: 120,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            whiteSpace: "break-spaces",
          }}
        >
          <span
            style={{
              cursor: "pointer",
            }}
          >
            {params.row.assigned_to_details?.name || "Not Assigned"}
          </span>
        </div>
      ),
    },
    {
      field: "phone",
      headerName: "Phone Number",
      width: 100,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            whiteSpace: "break-spaces",
          }}
        >
          <span
            style={{
              cursor: "pointer",
            }}
          >
            {params.row.phone_number}
          </span>
        </div>
      ),
    },

    {
      field: "created_at",
      headerName: "Date",
      width: 150,
      renderCell: (params) => {
        const formattedDate = moment
          .utc(params.row.created_at)
          .format("DD-MM-YYYY");
        return (
          <Typography style={{ color: "#6f6f6f" }}>{formattedDate}</Typography>
        );
      },
    },
    {
      field: "source_name",
      headerName: "Source",
      width: 80,
      renderCell: (params) => {
        return (
          <Typography style={{ color: "#6f6f6f" }}>
            {params.row?.source}
          </Typography>
        );
      },
    },
    {
      field: "project_name",
      headerName: "Project Name",
      width: 450,
      cellClassName: "wrap-text-cell",
      renderCell: (params) => {
        return (
          <Typography sx={{ color: "#6f6f6f", whiteSpace: "normal !important" }}>
            {params.row?.project?.name}
          </Typography>
        );
      },
    },
      {
      field: "status",
      headerName: "Status",
      width: 150,
      renderCell: (params) => {
        return (
          <Typography style={{ color: "#6f6f6f" }}>
            {params.row?.crm_status_details?.name}
          </Typography>
        );
      },
    },
  
  ];
  const [selectedChats, setSelectedChats] = useState([]);
  const [clickedMessage, setClickedMessage] = useState(null);
  const [multipSelector, setMultiSelector] = useState(false);
  const [openMultiSendPopup, setMultiSendPopup] = useState(false);
  const [loading, setLoading] = useState(true);
  const [chats, setChats] = useState([]);
  const [serachEntry, setSearchEntry] = useState("");
  const { GlobalRefresh } = GlobalRefreshContext();
  const [selectedRow, setSelectedRow] = useState([]);
  const [refresh, setRefresh] = useState(0);
  const [filterData, setFilterData] = useState({
    from: "",
    to: "",
    assing_to_users: "",
    lead_source: "",
    campaign_name: "",
    project:'',
    status:'',
  });
    const leadTypeData = JSON.parse(sessionStorage.getItem('Lead_type'));
    const projectData = JSON.parse(sessionStorage.getItem('project'));

  const location = useLocation();

  const navigate = useNavigate();
  const getPageNumber = () => {
    const queryParams = new URLSearchParams(location.search);
    return queryParams.get("page");
  };

  const pageNumber = getPageNumber();
  const [leads, setLeads] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 100,
    page: pageNumber || 0,
  });
  const [filterPopup, setShowFilterPopup] = useState(false);
  const [TemplateData, setTemplateData] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showProgressBox, setShowProgressBox] = useState(false);

  // Check if there's an ongoing batch process on component mount
  useEffect(() => {
    const savedBatchState = localStorage.getItem('bulkMessageBatchState');
    if (savedBatchState) {
      const batchState = JSON.parse(savedBatchState);
      // Show progress box if there's an ongoing batch
      if (batchState.status === 'processing' || batchState.status === 'pending') {
        setShowProgressBox(true);
      }
    }
  }, []);

  const closeFilterBadge = (filterName) => {
    if (selectedChats.length > 0) {
      setSelectedChats([]);
    }
    setFilterData((prevFilterData) => ({
      ...prevFilterData,
      [filterName]: null,
    }));
    setValue(filterName, null);
    setRefresh(Math.random);
  };

  useEffect(() => {
    fetchLeads();
  }, [serachEntry, refresh, GlobalRefresh, filterData, paginationModel]);

  const onMultiSend = () => {
    setMultiSendPopup(true);
    // Ensure progress box is hidden when opening the template selector
    setShowProgressBox(false);
  };

  const handlePageChange = (newPaginationModel) => {
    setPaginationModel(newPaginationModel);
    setRefresh(Math.random);
  };

const handleRowSelection = (newSelection) => {
  setSelectedRow((prevSelected) => {
    const newSet = new Set(prevSelected);

    // Add new selected IDs
    newSelection.forEach((id) => newSet.add(id));

    // Remove unselected IDs that were on the current page
    leads.data.forEach((row) => {
      if (!newSelection.includes(row.id)) {
        newSet.delete(row.id);
      }
    });
    setMultiSelector(true);
    setSelectedChats(Array.from(newSet));
    return Array.from(newSet);
  });
  
};




  const fetchLeads = async () => {
    try {
      const response = await BulkMessage.get({
        page: parseInt(paginationModel?.page) + 1,
        crm_lead_type_id: leadTypeData?.ID,
        project_id: projectData.ID,
        assigned_users: filterData?.assing_to_users,
        lead_source: filterData?.lead_source,
        filter: serachEntry || watch("searchbynameorphoneoremail"),
        campaign_name: filterData?.campaign_name,
        project_id:filterData?.project,
        limit: paginationModel?.pageSize || 100,
        crm_status:filterData.status,
        from_date: filterData?.from,
        to_date: filterData?.to
      });
      setLeads(response.data.leads);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    } finally {
    }
  };

  const showFilters = () => {
    setShowFilterPopup(true);
  };
  const handleFilter = () => {
    setSelectedChats([]);
    setMultiSelector(false);
    setSelectedRow([]);
    setLoading(true);
   setFilterData({
  from: watch("from") ? moment(watch("from")).format("DD-MM-YYYY") : undefined,
  to: watch("to") ? moment(watch("to")).format("DD-MM-YYYY") : undefined,

  assing_to_users:
    Array.isArray(watch("assing_to_users")) && watch("assing_to_users").length > 0
      ? watch("assing_to_users").map((assignUser) => assignUser.id)
      : null,

  lead_source:
    Array.isArray(watch("lead_source")) && watch("lead_source").length > 0
      ? watch("lead_source").map((leadSource) => leadSource.name)
      : null,

  searchbynameorphoneoremail: watch("searchbynameorphoneoremail") || null,

  project:
   watch("project") && watch("project").id||null,
   
   status:
   watch("status") && watch("status")?.slug||null,
});
  
    setShowFilterPopup(false);
  };

  

  const handleClearSelection = () => {
    setSelectedChats([]);
    setSelectedRow([]);
  };


  return (
    <>
      <div className="page-cntr">
        <div className="lead-cntr follo-up-cntr">
          <div className="lead-table lead-page-cntr">
            <div className="title-sec">
              <Card
                sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}
              >
                <PageHeader title={"Bulk Message"} />
              </Card>
            </div>
          </div>

          {/* Progress Box Section */}
          {showProgressBox && (
            <Card sx={{ m: 0, mb: 3, p: 2 }} variant="outlined">
              <ProgressBox 
                open={showProgressBox} 
                onClose={() => {
                  setShowProgressBox(false);
                  // Clear the batch state when progress box is closed
                  localStorage.removeItem('bulkMessageBatchState');
                }} 
              />
            </Card>
          )}

          <>
            <Card
              sx={{ m: 0, p: 2 }}
              variant="outlined"
              className="lead-table followup-table"
            >
            <Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap", // optional, in case of responsiveness
    mb: 2,
    gap: 2,
  }}
>
  {/* Left Side: Search & Multi Selector */}
  <Box sx={{ display: "flex", alignItems: "center", }}>
    <TextField
      variant="outlined"
      placeholder="Search...."
      value={serachEntry}
      onChange={(e) => setSearchEntry(e.target.value)}
      sx={{ width: 250 }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon color="action" />
          </InputAdornment>
        ),
        endAdornment: serachEntry && (
          <InputAdornment position="end">
            <IconButton size="small" onClick={() => setSearchEntry("")}>
              <CloseIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />

    {multipSelector && selectedChats.length >= 1 && (
      <>
        <FilterBadges
          label={"Selected"}
          value={selectedChats.length}
          handleClose={handleClearSelection}
        />
        <Button
          sx={{
            background: "#FAAB53",
            color: "white !important",
            ":hover": { background: "#FAAB53" },
          }}
          onClick={onMultiSend}
        >
          Send
        </Button>
      </>
    )}
  </Box>

  {/* Middle: Filter Badges */}
  <Box sx={{ display: "flex"}}>

 {filterData?.from && (<FilterBadges label={"From"} value={filterData.from} handleClose={() => closeFilterBadge('from')} />)}

                        {filterData?.to && (<FilterBadges label={"To"} value={filterData.to} handleClose={() => closeFilterBadge('to')} />)}

    {filterData?.assing_to_users?.length > 0 && (
      <FilterBadges
        label={"Assigned User"}
        value={`${filterData?.assing_to_users.length} option selected`}
        handleClose={() => closeFilterBadge("assing_to_users")}
      />
    )}

    {filterData?.lead_source?.length > 0 && (
      <FilterBadges
        label={"Lead Source"}
        value={`${filterData?.lead_source.length} option selected`}
        handleClose={() => closeFilterBadge("lead_source")}
      />
    )}

    {filterData?.project && (
      <FilterBadges
        label={"Project"}
     value={`1 option selected`}
        handleClose={() => closeFilterBadge("project")}
      />
    )}
        {filterData?.status && (
      <FilterBadges
        label={"Status"}
     value={`1 option selected`}
        handleClose={() => closeFilterBadge("status")}
      />
    )}
  </Box>

  {/* Right Side: Filter Button */}
  <Box>
    <IconButton
      sx={{ padding: 1, background: "#e5e5e5" }}
      onClick={showFilters}
    >
      <FilterListIcon />
    </IconButton>
  </Box>
</Box>

              {loading ? (
                <Box
                  sx={{
                    width: "100%",
                    marginTop: 10,
                    height: 20,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Waveform size={40} lineWeight={3.5} speed={1} color="blue" />
                </Box>
              ) : (
                <>
                  <>
                    {leads.data?.length > 0 ? (
                      <Fragment>
                        <Card
                          sx={{
                            m: 0,
                          }}
                          variant="outlined"
                          class="lead-table"
                        >
                          {typeof leads.data === "object" && (
                            <DataGrid
                              sx={{
                                width: "100%",
                              }}
                              paginationMode="server"
                              rows={leads?.data}
                              paginationModel={paginationModel}
                              columns={columns}
                              rowCount={leads?.total}
                              rowHeight={70}
                              autoHeight={true}
                              scrollbarSize={10}
                              density="comfortable"
                              rowSelectionModel={selectedRow}
                              checkboxSelection
                              onPaginationModelChange={handlePageChange}
                              onRowSelectionModelChange={handleRowSelection}
                              disableColumnMenu
                              disableExtendRowFullWidth
                            />
                          )}
                        </Card>
                      </Fragment>
                    ) : (
                      <Box
                        sx={{
                          width: "100%",
                          marginTop: 15,
                          height: 40,
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Typography>Bulk message not found</Typography>
                      </Box>
                    )}
                  </>
                </>
              )}
            </Card>
          </>
        </div>
      </div>
      <MultiTemplateSender
        open={openMultiSendPopup}
        setOpen={setMultiSendPopup}
        totalSelected={selectedRow.length}
        setTemplateData={setTemplateData}
        selectedChats={selectedChats}
        setSelectedChats={setSelectedChats}
        TableUpdate={fetchLeads}
        watch={watch}
        setSelectedRow={setSelectedRow}
        setSearchEntry={setSearchEntry}
        // Pass the function to show progress box when multisend is triggered
        onMultiSendTriggered={() => setShowProgressBox(true)}
      />
      {filterPopup && (
        <Filters
          open={filterPopup}
          setOpen={setShowFilterPopup}
          watch={watch}
          control={control}
          reset={reset}
          handleFilter={handleFilter}
          setFilterData={setFilterData}
          setValue={setValue}
          selectedChats={selectedChats}
          setSelectedChats={setSelectedChats}
        />
      )}
      <ProgressBox 
        open={showProgressBox} 
        onClose={() => {
          setShowProgressBox(false);
          // Clear the batch state when progress box is closed
          localStorage.removeItem('bulkMessageBatchState');
        }} 
      />
    </>
  );
}

export default Index;
